export const PaymentSuccessView = () => {
    return (
        <div>
            <h1>Payment Success</h1>
        </div>
    );
};